// app/javascript/components/Sidebar.jsx
import React, { useState, useEffect } from 'react';
import { t } from '../utils/i18n';
import { hasRole } from '../utils/roleHelper';

const Sidebar = ({ user, onNavigate, currentView, subView = 'military' }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const isAdmin = hasRole(user, 'admin');
  const isPersonnel = hasRole(user, 'personnel');
  const isDepartment = hasRole(user, 'department_head');
  const isPersonnelViewer = hasRole(user, 'personnel_viewer');
  useEffect(() => {
    // Re-run custom.js initialization
    if (window.$ && window.$.fn) {
      $(".customSelect").selectmenu();
      $(".customDatepicker").datepicker({
        showOn: "button",
        buttonImageOnly: false,
        buttonText: ""
      });
    }
  }, [currentView]);

  const handleNavClick = (e, key) => {
    e.preventDefault();
    // Force re-render if switching between leave types on same page
    if (currentView.startsWith('leave') && key.startsWith('leave') && currentView !== key) {
      onNavigate('');
      setTimeout(() => onNavigate(key), 0);
    } else if (currentView.startsWith('personnel') && key.startsWith('personnel') && currentView !== key) {
      onNavigate('');
      setTimeout(() => onNavigate(key), 0);
    } else {
      onNavigate(key);
    }

    setOpenDropdown(null);
  };

  const toggleDropdown = (e, dropdownKey) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenDropdown(openDropdown === dropdownKey ? null : dropdownKey);
  };

  useEffect(() => {
    const handleClickOutside = () => {
      setOpenDropdown(null);
    };

    if (openDropdown) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [openDropdown]);

  return (
    <aside className="leftBar">
      <nav className="navbar navbar-expand-md" id="myHeader">
        <a className="navbar-brand" href="#">
          <img src="/images/logo.png" alt="" />
        </a>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav">
            {!isPersonnelViewer && (
              <li className="nav-item">
                <a
                  className={`nav-link ${currentView === 'dashboard' ? 'active' : ''}`}
                  href="#"
                  onClick={(e) => handleNavClick(e, 'dashboard')}
                >
                  <img src="/images/navIcon1.png" alt="" />
                  <span>{t('sidebar.dashboard')}</span>
                </a>
              </li>
            )}

            {isAdmin && (
              <li className="nav-item">
                <a
                  className={`nav-link ${currentView === 'add-personnel' ? 'active' : ''}`}
                  href="#"
                  onClick={(e) => handleNavClick(e, 'add-personnel')}
                >
                  <img src="/images/navIcon2.png" alt="" />
                  <span>{t('sidebar.army_registration')}</span>
                </a>
              </li>
            )}

            <li className="nav-item">
              <a className={`nav-link dropdown-toggle ${currentView.startsWith('personnel') ? 'active' : ''}`} href="#" onClick={(e) => toggleDropdown(e, 'personnel')} >
                <img src="/images/navIcon3.png" alt="" />
                <span>{t('sidebar.personnel')}</span>
              </a>
              {openDropdown === 'personnel' && (
                <ul className="dropdown-menu show">
                  {isAdmin || isDepartment || isPersonnelViewer ? (
                    // Admin and personnel_viewer see all army types
                    <>
                      <li className="nav-item"><a className={`sub_menu_item ${subView === 'military' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'personnel-military')} ><span>Puntland Darawiish Force</span></a></li>
                      <li className="nav-item"><a className={`sub_menu_item ${subView === 'police' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'personnel-police')}><span>Puntland Police Force</span></a></li>
                      <li className="nav-item"><a className={`sub_menu_item ${subView === 'discipline' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'personnel-discipline')}><span>Puntland Custodial Corps (Asluubta)</span></a></li>
                    </>
                  ) : (
                    (() => {
                      return user?.army_personnel?.army_type?.name === 'Puntland Military Force (Darawiish)' && (
                        <li className="nav-item"><a className={`sub_menu_item ${subView === 'military' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'personnel-military')} ><span>Puntland Darawiish Force</span></a></li>
                      ) ||
                        user?.army_personnel?.army_type?.name === 'Puntland Police Force' && (
                          <li className="nav-item"><a className={`sub_menu_item ${subView === 'police' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'personnel-police')}><span>Puntland Police Force</span></a></li>
                        ) ||
                        user?.army_personnel?.army_type?.name === 'Puntland Custodial Corps' && (
                          <li className="nav-item"><a className={`sub_menu_item ${subView === 'discipline' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'personnel-discipline')}><span>Puntland Custodial Corps (Asluubta)</span></a></li>
                        );
                    })()
                  )}
                </ul>
              )}
            </li>

            {isAdmin && (
              <li className="nav-item">
                <a
                  className={`nav-link ${currentView === 'departments' ? 'active' : ''}`}
                  href="#"
                  onClick={(e) => handleNavClick(e, 'departments')}
                >
                  <img src="/images/navIcon4.png" alt="" />
                  <span>{t('sidebar.departments')}</span>
                </a>
              </li>
            )}

            {(isAdmin || hasRole(user, 'payroll_officer') || hasRole(user, 'finance_officer') || hasRole(user, 'finance_director') || hasRole(user, 'finance') || hasRole(user, 'director_general') || hasRole(user, 'accountant_general')) && (
              <li className="nav-item">
                <a className={`nav-link dropdown-toggle ${currentView.startsWith('payroll') ? 'active' : ''}`} href="#" onClick={(e) => toggleDropdown(e, 'payroll')}>
                  <img src="/images/navIcon5.png" alt="" />
                  <span>{t('sidebar.payroll')}</span>
                </a>
                {openDropdown === 'payroll' && (
                  <ul className="dropdown-menu show">
                    <li className="nav-item">
                      <a className={`sub_menu_item ${currentView === 'payroll' && subView === 'military' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'payroll-military')}>
                        <span>Puntland Military Force</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className={`sub_menu_item ${currentView === 'payroll' && subView === 'police' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'payroll-police')}>
                        <span>Puntland Police Force</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className={`sub_menu_item ${currentView === 'payroll' && subView === 'discipline' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'payroll-discipline')}>
                        <span>Puntland Custodial Corps (Asluubta)</span>
                      </a>
                    </li>
                  </ul>
                )}
              </li>
            )}

            {!isPersonnelViewer && (
              <li className="nav-item">
                <a className={`nav-link dropdown-toggle ${currentView.startsWith('attendance') ? 'active' : ''}`} href="#" onClick={(e) => toggleDropdown(e, 'attendance')}>
                  <img src="/images/navIcon8.png" alt="" />
                  <span>Attendance</span>
                </a>
                {openDropdown === 'attendance' && (
                  <ul className="dropdown-menu show">
                    {isAdmin && (
                      <>
                        <li className="nav-item">
                          <a className={`sub_menu_item ${subView === 'daily' ? 'active' : ''} `} href="#" onClick={(e) => handleNavClick(e, 'attendance-daily')}>
                            <span>Daily Attendance</span>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a className={`sub_menu_item ${subView === 'live' ? 'active' : ''} `} href="#" onClick={(e) => handleNavClick(e, 'attendance-live')} >
                            <span>Live Monitoring</span>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a className={`sub_menu_item ${subView === 'corrections' ? 'active' : ''} `} href="#" onClick={(e) => handleNavClick(e, 'attendance-corrections')} >
                            <span>Corrections</span>
                          </a>
                        </li>
                      </>
                    )}

                    {(isAdmin || isDepartment) && (
                      <li className="nav-item">
                        <a className={`sub_menu_item ${subView === 'settings' ? 'active' : ''} `} href="#" onClick={(e) => handleNavClick(e, 'attendance-settings')} >
                          <span>Settings</span>
                        </a>
                      </li>
                    )}
                    {isAdmin && (
                      <li className="nav-item">
                        <a className={`sub_menu_item ${subView === 'biometric' ? 'active' : ''} `} href="#" onClick={(e) => handleNavClick(e, 'attendance-biometric')} >
                          <span>Biometric Devices</span>
                        </a>
                      </li>
                    )}
                    <li className="nav-item">
                      <a className={`sub_menu_item ${subView === 'my' ? 'active' : ''} `} href="#" onClick={(e) => handleNavClick(e, 'attendance-my')} >
                        <span>My Attendance</span>
                      </a>
                    </li>
                    {!isAdmin && (
                      <li className="nav-item">
                        <a className={`sub_menu_item ${subView === 'corrections' ? 'active' : ''} `} href="#" onClick={(e) => handleNavClick(e, 'attendance-corrections')} >
                          <span>Request Correction</span>
                        </a>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            )}

            {!isPersonnelViewer && (
              <li className="nav-item">
                <a className={`nav-link dropdown-toggle ${currentView.startsWith('leave') || currentView === 'leave_management' ? 'active' : ''}`} href="#" onClick={(e) => toggleDropdown(e, 'leave')} >
                  <img src="/images/navIcon6.png" alt="" />
                  <span>{t('sidebar.leave_management', 'Leave Management')}</span>
                </a>
                {openDropdown === 'leave' && (
                  <ul className="dropdown-menu show">
                    {isAdmin || isDepartment ? (
                      // Admin sees all army types
                      <>
                        <li className="nav-item"><a className={`sub_menu_item ${subView === 'military' && currentView !== 'leave_management' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'leave-military')} ><span>Puntland Darawiish Force Leave</span></a></li>
                        <li className="nav-item"><a className={`sub_menu_item ${subView === 'police' && currentView !== 'leave_management' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'leave-police')}><span>Puntland Police Force Leave</span></a></li>
                        <li className="nav-item"><a className={`sub_menu_item ${subView === 'discipline' && currentView !== 'leave_management' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'leave-discipline')}><span>Puntland Custodial Corps (Asluubta) Leave</span></a></li>
                      </>
                    ) : (
                      (() => {
                        return user?.army_personnel?.army_type?.name === 'Puntland Military Force (Darawiish)' && (
                          <li className="nav-item"><a className={`sub_menu_item ${subView === 'military' && currentView !== 'leave_management' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'leave-military')} ><span>Puntland Darawiish Force Leave</span></a></li>
                        ) ||
                          user?.army_personnel?.army_type?.name === 'Puntland Police Force' && (
                            <li className="nav-item"><a className={`sub_menu_item ${subView === 'police' && currentView !== 'leave_management' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'leave-police')}><span>Puntland Police Force Leave</span></a></li>
                          ) ||
                          user?.army_personnel?.army_type?.name === 'Puntland Custodial Corps (Asluubta)' && (
                            <li className="nav-item"><a className={`sub_menu_item ${subView === 'discipline' && currentView !== 'leave_management' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'leave-discipline')}><span>Puntland Custodial Corps (Asluubta) Leave</span></a></li>
                          );
                      })()
                    )}
                    {isAdmin && (
                      <li className="nav-item" style={{ borderTop: '1px solid #eee', marginTop: '4px', paddingTop: '4px' }}>
                        <a className={`sub_menu_item ${currentView === 'leave_management' ? 'active' : ''}`} href="#" onClick={(e) => handleNavClick(e, 'leave_management')}>
                          <span>Leave Configuration & Rules</span>
                        </a>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            )}

            {isAdmin && (
              <li className="nav-item">
                <a
                  className={`nav-link ${currentView === 'location' ? 'active' : ''}`}
                  href="#"
                  onClick={(e) => handleNavClick(e, 'location')}
                >
                  <img src="/images/navIcon6.png" alt="" />
                  <span>{t('sidebar.location')}</span>
                </a>
              </li>
            )}

            {isAdmin && (
              <li className="nav-item">
                <a
                  className={`nav-link ${currentView === 'id_cards' ? 'active' : ''}`}
                  href="#"
                  onClick={(e) => handleNavClick(e, 'id_cards')}
                >
                  <img src="/images/navIcon6.png" alt="" />
                  <span>{t('sidebar.id_cards')}</span>
                </a>
              </li>
            )}

            {!isPersonnelViewer && (
              <li className="nav-item">
                <a
                  className={`nav-link ${currentView === 'reports' ? 'active' : ''}`}
                  href="#"
                  onClick={(e) => handleNavClick(e, 'reports')}
                >
                  <img src="/images/navIcon7.png" alt="" />
                  <span>{t('sidebar.reports')}</span>
                </a>
              </li>
            )}

            {isAdmin && (
              <li className="nav-item">
                <a
                  className={`nav-link ${currentView === 'biometric_devices' ? 'active' : ''}`}
                  href="#"
                  onClick={(e) => handleNavClick(e, 'biometric_devices')}
                >
                  <img src="/images/navIcon8.png" alt="" />
                  <span>{t('sidebar.biometric_devices')}</span>
                </a>
              </li>
            )}

            {isAdmin && (
              <li className="nav-item">
                <a
                  className={`nav-link ${currentView === 'users' ? 'active' : ''}`}
                  href="#"
                  onClick={(e) => handleNavClick(e, 'users')}
                >
                  <img src="/images/navIcon9.png" alt="" />
                  <span>{t('sidebar.users')}</span>
                </a>
              </li>
            )}

            {isAdmin && (
              <li className="nav-item">
                <a
                  className={`nav-link ${currentView === 'army_type' ? 'active' : ''}`}
                  href="#"
                  onClick={(e) => handleNavClick(e, 'army_type')}
                >
                  <img src="/images/navIcon10.png" alt="" />
                  <span>{t('sidebar.army_type')}</span>
                </a>
              </li>
            )}

            {isAdmin && (
              <li className="nav-item">
                <a
                  className={`nav-link ${currentView === 'ranks' || currentView === 'rank_management' ? 'active' : ''}`}
                  href="#"
                  onClick={(e) => handleNavClick(e, 'ranks')}
                >
                  <img src="/images/navIcon4.png" alt="" />
                  <span>{t('sidebar.ranks', 'Ranks')}</span>
                </a>
              </li>
            )}

            {isAdmin && (
              <li className="nav-item">
                <a
                  className={`nav-link ${currentView === 'audit' ? 'active' : ''}`}
                  href="#"
                  onClick={(e) => handleNavClick(e, 'audit')}
                >
                  <img src="/images/navIcon10.png" alt="" />
                  <span>{t('sidebar.audit')}</span>
                </a>
              </li>
            )}

            {isAdmin && (
              <li className="nav-item">
                <a
                  className={`nav-link ${currentView === 'workflow' ? 'active' : ''}`}
                  href="#"
                  onClick={(e) => handleNavClick(e, 'workflow')}
                >
                  <img src="/images/navIcon11.png" alt="" />
                  <span>{t('sidebar.workflow')}</span>
                </a>
              </li>
            )}
          </ul>
        </div>
      </nav>
    </aside>
  );
};

export default Sidebar;
